module.exports = __webpack_public_path__ + "img/04.b8967101.jpg";